module.exports = __webpack_public_path__ + "img/logo1.2e92d001.svg";